<template>
  <div v-show="activeBackDrop"
       class="modal scrol-custom fade" :id="id"
       aria-modal="true"
       :data-backdrop="activeBackDrop ? 'static' : true"
       :data-keyboard="!activeBackDrop"
       style="display: none; border-radius: 0;"
  >
    <div class=" modal-dialog modal-dialog-centered modal-dialog-scrollable"
         :class="{'modal-sm': size === 'small', 'modal-lg': size === 'large', 'modal-xl': size === 'extra-large'}">
      <div
          class="modal-content"
          style="border-radius: 20px;"
          :style="{'height': fixedHeight ? '100vh' : 'auto' }"
      >
        <div v-if="title !== ''" class="modal-header"
             style="padding: 10px 15px; color: white">
          <h4 class="modal-title" style="font-size: 14pt; font-weight: bold; text-transform: uppercase">{{ title }}</h4>
            <span class="fa fa-times fa-3x m-action" @click="hide()"></span>
        </div>
        <div class="modal-body scrol-custom" :class="{'p-0': !padding}">
          <slot></slot>
        </div>
        <div v-if="showFooter" class="modal-footer justify-content-between">
          <slot name="actions"/>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
</template>

<script>
export default {
  props: {
    activeBackDrop: {
      type: Boolean,
      default: false
    },
    isShow: {
      type: Boolean,
      default: false
    },
    padding: {
      type: Boolean,
      default: true
    },
    id: {
      type: Number
    },
    title: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: ""
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    fixedHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isShow(val) {
      if (val) {
        this.show()
      } else {
        this.hide();
      }
    }
  },
  methods: {
    show() {
      $(this.$el).modal("show");
    },
    hide() {
      $(this.$el).modal("hide");
      setTimeout(() => {
        this.$emit('closeModal')
      }, 500)
    }
  }
};
</script>
<style scoped>
@media (min-width: 1200px) {
  .modal-xl {
    max-width: 100%;
  }

  .modal-xl .modal-content {
    height: 95vh
  }
}

</style>
